<template>
  <div class="mb-3">
    <div class="table-responsive">
      <table class="table table-striped table-hover align-middle mb-0">
        <thead>
          <tr>
            <th>ID</th>
            <th>Tipo</th>
            <th>Arquivo</th>
            <th>Período</th>
            <th>Válidas</th>
            <th>Auto</th>
            <th>Pendentes</th>
            <th>Data</th>
          </tr>
        </thead>

        <tbody>
          <tr v-if="!items.length">
            <td colspan="8" class="text-center text-muted py-4">
              Nenhuma importação encontrada.
            </td>
          </tr>

          <tr v-for="item in items" :key="item.id">
            <td>{{ item.id }}</td>
            <td>{{ item.tipo_importacao }}</td>
            <td>{{ item.nome_arquivo }}</td>
            <td>{{ periodo(item) }}</td>
            <td>{{ item.total_validas }}</td>
            <td>{{ item.total_conciliadas_automatico }}</td>
            <td>{{ item.total_pendentes }}</td>
            <td>{{ formatDateTime(item.criado_em) }}</td>
          </tr>
        </tbody>
      </table>
    </div>

    <div v-if="pagination" class="d-flex justify-content-between align-items-center mt-3 flex-wrap gap-2">
      <div>
        Mostrando {{ startRow }} a {{ endRow }} de {{ pagination.total || 0 }} registros
      </div>

      <div class="d-flex align-items-center" style="gap: .5rem;">
        <select
          class="form-select form-select-sm"
          style="width: 6rem"
          :value="pagination.limit || 10"
          @change="emit('change-limit', Number($event.target.value))"
        >
          <option v-for="n in pageOptions" :key="n" :value="n">
            {{ n }} / página
          </option>
        </select>
      </div>

      <div class="d-flex align-items-center">
        <BPagination
          :model-value="pagination.page || 1"
          :per-page="pagination.limit || 10"
          :total-rows="pagination.total || 0"
          size="sm"
          limit="5"
          first-text="«"
          prev-text="‹"
          next-text="›"
          last-text="»"
          @update:model-value="emit('change-page', $event)"
        />
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue'
import { BPagination } from 'bootstrap-vue-next'

const props = defineProps({
  items: { type: Array, default: () => [] },
  pagination: { type: Object, default: () => ({}) }
})

const emit = defineEmits(['change-page', 'change-limit'])

const pageOptions = [10, 15, 20, 25, 50]

const startRow = computed(() => {
  const total = Number(props.pagination?.total || 0)
  if (!total) return 0
  const page = Number(props.pagination?.page || 1)
  const limit = Number(props.pagination?.limit || 10)
  return (page - 1) * limit + 1
})

const endRow = computed(() => {
  const total = Number(props.pagination?.total || 0)
  if (!total) return 0
  const page = Number(props.pagination?.page || 1)
  const limit = Number(props.pagination?.limit || 10)
  return Math.min(page * limit, total)
})

function periodo(item) {
  if (!item.periodo_inicio && !item.periodo_fim) return '—'
  return `${formatDate(item.periodo_inicio)} a ${formatDate(item.periodo_fim)}`
}

function formatDate(v) {
  if (!v) return '—'
  const [y, m, d] = String(v).slice(0, 10).split('-')
  return `${d}/${m}/${y}`
}

function formatDateTime(v) {
  if (!v) return '—'
  const iso = String(v).replace(' ', 'T')
  const dt = new Date(iso)
  return dt.toLocaleString('pt-BR')
}
</script>

<style scoped>
.table {
  margin-bottom: 0;
}

.table th {
  font-size: 0.78rem;
  font-weight: 600;
  white-space: nowrap;
  vertical-align: middle;
}

.table td {
  font-size: 0.83rem;
  vertical-align: middle;
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
}

:deep(.pagination.pagination-sm .page-link) {
  font-size: 0.8rem;
  line-height: 1;
  border-radius: 0 !important;
}

:deep(.pagination.pagination-sm) {
  margin-bottom: 0;
}

:deep(.pagination.pagination-sm .page-item.active .page-link) {
  z-index: 1;
}
</style>